var _style, _circle, _path, _g, _g2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#338AF3;}\n\t.st2{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    className: "st1",
    d: "M256,189.2h247.2c-6.4-23.8-16.2-46.3-28.8-66.8H256V189.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,456.3h318.7c23.4-18.6,43.4-41.2,59.1-66.8H37.6C53.2,415.1,73.3,437.7,96.6,456.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0v55.7h159.4C371.6,20.8,316.2,0,256,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    className: "st1",
    d: "M256,189.2h247.2c-6.4-23.8-16.2-46.3-28.8-66.8H256V189.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,256c0,23.1,3.1,45.5,8.8,66.8h494.4c5.7-21.3,8.8-43.7,8.8-66.8H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M222.6,149.8l-31.3,14.7l16.6,30.3l-33.9-6.5l-4.3,34.3l-23.6-25.2l-23.6,25.2l-4.3-34.3l-33.9,6.5l16.6-30.3 l-31.3-14.7l31.3-14.7l-16.6-30.3l33.9,6.5l4.3-34.3l23.6,25.2L169.7,77l4.3,34.3l34-6.5l-16.6,30.3L222.6,149.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUy);
export default __webpack_public_path__ + "static/media/uy.f15237c31559b4bdf7a88ddd2a3c5bb4.svg";
export { ForwardRef as ReactComponent };